import { useSelector } from "react-redux";
import { IAppState } from "../store/types";

export const useSessionTokenSelector = () => {
  return useSelector((state: IAppState) => {
    return state.auth.session?.DataToken;
  });
};
